import { useMemo } from 'react'

import { SWRConfiguration } from 'swr'

import { PreviewSubscriptionRequest, SubscriptionPreviewResponse } from '@infura/packages.api'
import { ErrorResponse } from '@infura/packages.chargify'

import { useApi } from 'lib/api/api'

const defaultConfig: SWRConfiguration = { errorRetryCount: 0, revalidateOnFocus: false, shouldRetryOnError: false }

export default function useSubscriptionPreview(body: PreviewSubscriptionRequest, config?: SWRConfiguration) {
  const swrConfig = useMemo(() => ({ ...defaultConfig, ...config }), [config])
  const { data: subscriptionPreviewResponse, error, ...swr } = useApi(['previewSubscription', body], swrConfig)

  return {
    error: error as ErrorResponse,
    loading: !subscriptionPreviewResponse && !error,
    preview: subscriptionPreviewResponse as SubscriptionPreviewResponse,
    ...swr
  }
}
